import { Component, OnInit, Input, ViewChild } from "@angular/core";
import { Http } from "@angular/http";
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { PMS } from "../preventive-maintenance/pms-service";
import { Pipe } from "@angular/core";
import {
  ToastyService,
  ToastyConfig,
  ToastOptions,
  ToastData,
} from "ng2-toasty";
declare var $: any;
import * as moment from "moment/moment";

import { IOption } from "ng-select";
import { Popup } from "ng2-opd-popup";

@Component({
  selector: "app-service-contract",
  templateUrl: "./service-contract.component.html",
  styleUrls: ["./service-contract.component.scss"],
  //providers: [FormBuilderComponent]
})
export class ServiceContractComponent implements OnInit {
  loading: boolean = false;
  ListofSublocality = [];
  newsubLocality_err: boolean = false;
  subLocality: any;
  emirates: any;
  subLocalityOptions: Array<IOption> = [];
  emiratesOptions: Array<IOption> = [];
  BranchDropDown: Array<IOption> = [];
  subLocalityedit = "SELECT A SUBLOCALITY";
  emiratesedit: string = "SELECT THE EMIRATES";
  BranchPlaceholder = "CHOOSE THE BRANCH";
  ListEmiratesdetails = [];
  alerttxt = "";
  serviceUpdateTypeSelect: Array<IOption> = [];
  ListOfCheckListMasterdropdown: Array<IOption> = [];
  ListSerialNumberOption: Array<IOption> = [];
  postponedatevalid: boolean = true;
  msgtext: string;
  ListTechnicianName: any[] = [];
  ListOfCheckListMaster: any[] = [];
  ListOfCustomermaster: any[] = [];
  ListOfFields: any[] = [];
  ListOfSecondFields: any[] = [];
  clientName: any;
  serialnumber: any;
  mclocation: any;
  noofService: any;
  startdate: any;
  endDate: any;
  make: any;
  intervalofservice: any;
  model: any;
  hmrHours: any;
  technicianName: any;
  lastServiceType: any;
  lastServiceHour: any;
  yearofmanufacturer: any;
  branch: any;
  serviceContractOffered: any;
  contractReference: any;
  clientPhonenumber: any;
  email: any;
  ListSerialNumber: any[] = [];
  textField: boolean = true;
  dropdownField: boolean = false;
  getListClientdetails: any[] = [];
  showModal: boolean = false;
  chooseClientname: any;
  dialogConfirmation: any;
  serviceScheduleNumber: any;
  serviceCarriedOutDate: any;
  nextServiceRemainderDays: any;
  nextServiceType: any;
  preventiveId: any;
  isValid: boolean = true;
  nextServiceChecking: number = 0;
  FinalCount: any;
  reqMakeId: number;
  reqmodelId: number;
  CustomerName: any;
  ListOfPreventiveMaintenanceDetails = [];
  serialNumbercounterr: boolean = false;
  NewSerialNumber: any;
  serviceUpdateType: any = "dateUpdation";
  currentdatedisabled: boolean = false;
  newserialNumber: number;
  newstartdate: any;
  newenddate: any;
  newextensiondate: any;
  extensionUpdateId;
  config2: any = {
    placeholder: "Serial Number",
    sourceField: ["serial_Number"],
  };
  @ViewChild("Newadd") Newadd: Popup;
  @ViewChild("ServiceMismatch") ServiceMismatch: Popup;
  @ViewChild("alert") alert: Popup;
  @ViewChild("ContractExtension") ContractExtension: Popup;
  @ViewChild("contractDetailsEdit") contractDetailsEdit: Popup;
  @ViewChild("currentDetails") currentDetails: Popup;
  selectedItem: any = "";
  inputChanged: any = "";
  sst: any;
  newintervalofDays: any;
  numberlessthanremaindererr: boolean = false;
  numberofDayDisable: any = 15;
  lastServiceStatus: boolean = false;
  NoOfServiceContractYear: any;
  serviceCompletion: boolean = false;
  serviceRemainderDays: any;
  orgId: number;
  userId: number;
  Listbranchdetails = [];
  expanded: boolean = false;
  lat: number = 25.258377032270545;
  lng: number = 55.37882738702092;
  latitude: any;
  longitude: any;
  durationCount: number;
  secToMin = 0; //checking into mins
  secToHours = 0;
  secToHours_Remainder = 0;
  Hoursprice = 0;
  FinalDuration = 0;
  Price = 0;
  seconds = 0;
  mcLocationerr: boolean = false;
  locality: string;
  pdfSrc: string = "";
  contractLevel: number;
  intervalediterr: boolean = false;
  makeName: any;
  modelName: any;
  brancherr: boolean = false;
  travelhours = 0;
  minstravel = 0;
  Finalmins = 0;
  english = /^[A-Za-z]*$/;
  TravelCostValuearr = [];
  TravelcostValue: number = 0;
  originalEndDate: any;
  previousServiceDateSnapshot: any = "";
  latlong: Array<{ latitude: number; longitude: number }> = [];
  constructor(
    private toastyService: ToastyService,
    private toastyConfig: ToastyConfig,
    private http: Http,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.getEmptyAllField();
    console.log("[ServiceContract] release 2026-07-27 last-service-fix");
    if (
      this.route.params["value"].orgId === "" ||
      this.route.params["value"].orgId === undefined ||
      this.route.params["value"].orgId === null ||
      this.route.params["value"].userId === undefined ||
      this.route.params["value"].userId === "" ||
      this.route.params["value"].userId === null
    ) {
      window.location.href = "https://still.alshirawi.com/highmessaging/";
    } else {
      this.orgId = this.route.params["value"].orgId;
      this.userId = this.route.params["value"].userId;
      console.log("OrgId " + this.orgId);
      console.log("UserId " + this.userId);
    }
    $("#clientNamePla").attr("placeholder", "--choose client name");

    this.ListOfFields.push({
      PartNumber: "",
      description: "",
      quantity: "",
      UnitPrice: "",
      SellingPrice: "",
      serviceType: "",
      costType: "",
    });

    this.getAllPreventiveMaintenanceDetails();

    let pusharray = [];
    pusharray.push(
      { value: "dateUpdation", label: "Date Updation" },
      { value: "prepost", label: "Pre/Postpone" }
    );
    this.serviceUpdateTypeSelect = pusharray;
    console.log(this.ListOfSecondFields);
  }

  getAllCustomerMasterDetails() {
    this.loading = true;
    let CustomerObj = {
      orgId: this.orgId,
    };
    return this.http
      .post("/api/getCustomerMasterDetails", CustomerObj)
      .subscribe(
        (res) => {
          this.loading = false;
          this.ListOfCustomermaster = res.json();
        },
        (err) => {
          this.loading = false;
          if (err.status != 200) {
            this.msgtext = "Unable to load the Value";
            this.getWarningFunction(this.msgtext);
          }
        }
      );
  }

  getTravelCostvalues() {
    let obj = {
      orgId: this.orgId,
    };
    return this.http.post("/api/getTravelCost", obj).subscribe(
      (res) => {
        this.TravelCostValuearr = res.json();
        console.log("TravelCostValuearr", this.TravelCostValuearr);
        this.TravelcostValue = parseInt(this.TravelCostValuearr[0].TravelCost);
        console.log("TravelCostValue", this.TravelcostValue);
      },
      (err) => {
        console.log(err);
      }
    );
  }

  getEmiratedetails(emirates) {
    this.subLocality = "";
    this.subLocalityedit = "SELECT THE SUBLOCALITY";
    this.getAllSublocalitydetails();
  }

  getemiratesdetails() {
    let emiratesObj = {
      orgId: this.orgId,
    };
    return this.http.post("/api/getEmiratesdetails", emiratesObj).subscribe(
      (res) => {
        let responseEmirates = res.json();
        this.ListEmiratesdetails = responseEmirates.result_data;
        if (this.ListEmiratesdetails.length > 0) {
          console.log("this.ListEmiratesdetails", this.ListEmiratesdetails);
          let pusharr = [];
          for (let i = 0; i < this.ListEmiratesdetails.length; i++) {
            pusharr.push({
              value: this.ListEmiratesdetails[i]._id.toString(),
              label: this.ListEmiratesdetails[i].emirates.toUpperCase(),
            });
          }
          this.emiratesOptions = pusharr;
        } else {
        }
      },
      (err) => {
        if (err.status != 200) {
          this.alerttxt = "Unable to load the Emirates value";
          this.getWarningFunction(this.alerttxt);
        }
      }
    );
  }

  getsubLocalitydetails(value) {
    this.expanded = true;
    if (value == "" || value == undefined) {
      this.newsubLocality_err = true;
    } else if (
      this.emirates == "" ||
      this.emirates == null ||
      this.emirates == undefined
    ) {
      this.subLocality = "";
    } else {
      for (let i = 0; i < this.ListofSublocality.length; i++) {
        if (this.ListofSublocality[i]._id == parseInt(value)) {
          this.lat = parseFloat(this.ListofSublocality[i].latitude);
          this.lng = parseFloat(this.ListofSublocality[i].longitude);
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
          // this.zoomIn=14;
        }
      }
    }
  }

  getAllSublocalitydetails() {
    let Sublocality = {
      orgId: this.orgId,
    };
    return this.http.post("/api/getSubLocalitydetails", Sublocality).subscribe(
      (res) => {
        let responseSublocality = res.json();
        this.ListofSublocality = responseSublocality.result_data;

        if (this.ListofSublocality.length > 0) {
          //console.log("this.ListEmiratesdetails",this.ListEmiratesdetails);
          let pusharr = [];
          for (let i = 0; i < this.ListofSublocality.length; i++) {
            if (
              this.ListofSublocality[i].emirateid == parseInt(this.emirates)
            ) {
              pusharr.push({
                value: this.ListofSublocality[i]._id.toString(),
                label: this.ListofSublocality[i].sublocation.toUpperCase(),
              });
            }
          }
          this.subLocalityOptions = pusharr;
        } else {
        }
      },
      (err) => {
        if (err.status != 200) {
          this.alerttxt = "Unable to load the Sublocality value";
          this.getWarningFunction(this.alerttxt);
        }
      }
    );
  }

  toggle() {
    this.getbranchdetails();
    console.log(this.Listbranchdetails);
    this.expanded = !this.expanded;
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  renewalContract() {
    this.serialnumber;
    this.router.navigate([
      "node/preventiveMaintenance",
      {
        serialNumber: this.serialnumber,
        orgId: this.orgId,
        userId: this.userId,
        renewal: "yes",
      },
    ]);
  }

  getbranchdetails() {
    let branchObj = {
      orgId: this.orgId,
    };
    return this.http.post("/api/getbranchdetails", branchObj).subscribe(
      (res) => {
        let responseBranch = res.json();
        this.Listbranchdetails = responseBranch;
        let pusharray = [];
        for (let b = 0; b < this.Listbranchdetails.length; b++) {
          pusharray.push({
            value: this.Listbranchdetails[b]._id.toString(),
            label: this.Listbranchdetails[b].branchAlias,
          });
        }
        this.BranchDropDown = pusharray;
        console.log("Listbranchdetails", this.Listbranchdetails);
        if (this.latlong.length == 0) {
          for (let i = 0; i < this.Listbranchdetails.length; i++) {
            let obj = {
              latitude: parseFloat(this.Listbranchdetails[i].latitude),
              longitude: parseFloat(this.Listbranchdetails[i].longitude),
            };
            this.latlong.push(obj);
          }
          console.log("latlong", this.latlong);
        }
        this.loading = false;
        //console.log(responseBranch);
      },
      (err) => {
        this.loading = false;
        if (err.status != 200) {
          this.alerttxt = "Unable to load the branch value";
          this.getWarningFunction(this.alerttxt);
        }
      }
    );
  }

  mapClicked(Event) {
    this.latitude = Event.coords.lat;
    this.longitude = Event.coords.lng;
    this.durationCount = 0;
    this.travelhours = 0;
    this.minstravel = 0;
    this.Finalmins = 0;
    let originArr = [];
    let distinationArr = [];
    let distanceArr = [];
    this.branch = "";

    let addressobj = {
      lat_and_lang: Event.coords.lat + "," + Event.coords.lng,
    };
    return this.http
      .post(
        "https://still.alshirawi.com/highmessaging/getAllGoogleMapsWebserviceDetails",
        addressobj
      )
      .subscribe((res) => {
        let response = res.json();
        console.log("first Google API " + res.json());
        console.log("first Google API String" + JSON.stringify(res.json()));
        console.log(
          "Listbranchdetails after mapclicked",
          this.Listbranchdetails
        );
        this.mclocation = response.results[0].formatted_address;
        this.locality = response.results[0].formatted_address;
        for (
          let m = 0;
          m < response.results[0].address_components.length;
          m++
        ) {
          for (
            let t = 0;
            t < response.results[0].address_components[m].types.length;
            t++
          ) {
            if (
              response.results[0].address_components[m].types[t] ==
                "sublocality" ||
              response.results[0].address_components[m].types[t] ==
                "sublocality_level_1" ||
              response.results[0].address_components[m].types[t] == "locality"
            ) {
              this.locality =
                response.results[0].address_components[m].short_name;
              break;
            } else if (
              response.results[0].address_components[m].types[t] ==
              "administrative_area_level_1"
            ) {
              this.locality =
                response.results[0].address_components[m].short_name;
              break;
            } else if (
              response.results[0].address_components[m].types[t] ==
              "administrative_area_level_2"
            ) {
              this.locality =
                response.results[0].address_components[m].short_name;
              break;
            }
          }
        }
        console.log(
          "Listbranchdetails in mapclicked after forloop",
          this.Listbranchdetails
        );
        if (this.english.test(this.locality) == false) {
          this.locality = this.mclocation;
        } else {
          // alert('its English' + this.locality)
        }
        if (
          this.mclocation == "" ||
          this.mclocation == undefined ||
          this.mclocation == null
        ) {
          this.mcLocationerr = true;
        } else {
          this.mcLocationerr = false;
        }
        let loglatArr = [];
        for (let i = 0; i < this.Listbranchdetails.length; i++) {
          loglatArr.push(
            this.Listbranchdetails[i].latitude +
              "," +
              this.Listbranchdetails[i].longitude
          );
        }

        // let urlReq = "https://maps.googleapis.com/maps/api" + "/distancematrix/json?units=imperial&origins="+Event.coords.lat+","+Event.coords.lng+"&destinations="+loglatArr.join('|').toString()+"&key=AIzaSyA5qcFi5QycVzjof_zufO8MX8HoSwpGc5o";

        let distinationobj = {
          lat_and_lang: Event.coords.lat + "," + Event.coords.lng,
          destinations: loglatArr.join("|").toString(),
        };
        return this.http
          .post(
            "https://still.alshirawi.com/highmessaging/getAllGoogleMapsWebserviceDetails",
            distinationobj
          )
          .subscribe(
            (res) => {
              console.log("Second Google API" + res.json());
              console.log(
                "Second Google API String" + JSON.stringify(res.json())
              );
              let distanceResponse = res.json();
              let I_index = 0;
              let smallest =
                distanceResponse.rows[0].elements[0].duration.value;

              for (
                let i = 0;
                i < distanceResponse.rows[0].elements.length;
                i++
              ) {
                if (distanceResponse.rows[0].elements[i].status == "OK") {
                  if (
                    distanceResponse.rows[0].elements[i].duration.value <
                    smallest
                  ) {
                    smallest =
                      distanceResponse.rows[0].elements[i].duration.value;
                    I_index = i;
                  }
                }
              }

              this.branch = this.Listbranchdetails[I_index].branchAlias;
              this.BranchPlaceholder = this.branch;
              for (let i = 0; i < this.Listbranchdetails.length; i++) {
                if (this.branch == this.Listbranchdetails[i].branchAlias) {
                  this.branch = this.Listbranchdetails[i]._id.toString();
                }
              }
              console.log("branch", this.branch);

              console.log("Final Smallest Seconds " + smallest);
              //smallest = 6589;
              this.seconds = smallest;
              console.log("durationValue " + this.seconds);
              this.secToMin = Math.floor(this.seconds / 60); //checking into mins
              this.secToHours = 0;
              this.secToHours_Remainder = 0;
              this.Hoursprice = 0;
              this.FinalDuration = 0;
              this.Price = 0;
              this.travelhours = 0;
              this.Finalmins = 0;
              this.minstravel = 0;
              if (this.secToMin >= 60) {
                this.secToHours = Math.floor(this.seconds / 3600);
                this.travelhours = this.secToHours;
                // this.Hoursprice = this.secToHours*165;
                this.Hoursprice = this.TravelcostValue * this.secToHours;
                this.secToHours_Remainder = this.seconds % 3600;
                if (this.secToHours_Remainder <= 1800) {
                  this.Price = this.Hoursprice + this.TravelcostValue / 2;
                  this.minstravel = 0.5;
                } else if (
                  this.secToHours_Remainder > 1800 &&
                  this.secToHours_Remainder <= 2700
                ) {
                  this.Price = this.Hoursprice + (this.TravelcostValue * 3) / 4;
                  this.minstravel = 0.75;
                } else if (
                  this.secToHours_Remainder > 2700 &&
                  this.secToHours_Remainder < 3600
                ) {
                  // this.Price=this.Hoursprice+165;
                  this.Price = this.Hoursprice + this.TravelcostValue;
                  this.travelhours = this.travelhours + 1;
                }
              } else {
                if (this.secToMin <= 30) {
                  this.FinalDuration = 30;
                  this.minstravel = 0.5;
                } else if (this.secToMin > 30 && this.secToMin <= 45) {
                  this.FinalDuration = 45;
                  this.minstravel = 0.75;
                } else if (this.secToMin > 45) {
                  this.FinalDuration = 60;
                  this.travelhours = this.travelhours + 1;
                }
              }

              if (this.FinalDuration == 30) {
                this.Price = this.TravelcostValue / 2;
              } else if (this.FinalDuration == 45) {
                this.Price = (this.TravelcostValue * 3) / 4;
              } else if (this.FinalDuration == 60) {
                this.Price = this.TravelcostValue;
              }

              this.Finalmins = this.travelhours + this.minstravel;
              for (
                let sr = this.serviceScheduleNumber - 1;
                sr < this.ListOfSecondFields.length;
                sr++
              ) {
                this.ListOfSecondFields[sr].travel_Cost = (
                  this.Price * 2
                ).toFixed(2);

                this.ListOfSecondFields[sr].travel_hour = this.Finalmins * 2;
              }
            },
            (err) => {
              alert(err);
            }
          );
      });
  }

  onSelect(val: string) {
    this.selectedItem = val;
    this.InputFieldCheck(this.selectedItem);
  }

  onInputChangedEvent(val: string) {
    this.inputChanged = val;
    this.postponedatevalid = false;
    this.InputFieldCheck(this.inputChanged);
  }

  // addOk() {
  //   this.Newadd.hide();
  // }

  // editcancel() {
  //   this.contractDetailsEdit.hide();
  // }

  // no() {
  //   this.alert.hide();
  // }

  extensiondate(date) {
    if (date < this.newenddate) {
      alert("Extension date should be greater than End date");
      this.newextensiondate = "";
    }
  }

  // Ecancel() {
  //   this.ContractExtension.hide();
  // }

  Esave() {
    let CEobj = {
      serialNumber: this.newserialNumber,
      startDate: this.newstartdate,
      endDate: this.newenddate,
      contractLevel: this.contractLevel,
      extensionDate: this.newextensiondate,
      PM_ID: this.preventiveId,
      orgId: this.orgId,
      created_By: this.userId,
      created_Date: moment(new Date()).utc().format("YYYY:MM:DD h:mm:ss"),
    };
    return this.http
      .post("/api/extendServiceContractDuration", CEobj)
      .subscribe(
        (res) => {
          // this.spinner.hide();
          let Response = res.json();
          alert("service contract Extension successfully done.");
          //this.getAlldetails();
          this.InputFieldCheck(this.newserialNumber);
          $("#ContractExtension").modal("hide");
          // this.ContractExtension.hide();
        },
        (err) => {
          // this.spinner.hide();
          alert("unable to extend the service contract");
        }
      );
  }

  changeServiceCompletion(value) {
    this.serviceCompletion = value;
  }

  yes() {
    $("#alertPopup").modal("hide");
    $("#ContractExtension").modal("show");
    // this.ContractExtension.options = {
    //   showButtons: false, // You can hide this in case you want to use custom
    //   color: "#4180ab",
    //   header: "Service Updation Form"
    // };
    // this.ContractExtension.show(this.ContractExtension.options);
  }

  ServiceUpdateType(type) {
    if (type == "dateUpdation") {
      this.currentdatedisabled = false;
    } else if (type == "prepost") {
      this.currentdatedisabled = true;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      $("#ServiceMismatch").modal("show");
      // this.ServiceMismatch.options = {
      //   showButtons: false, // You can hide this in case you want to use custom
      //   color: "#4180ab",
      //   header: "Service Updation Form"
      // };
      // this.ServiceMismatch.show(this.ServiceMismatch.options);
    }
  }

  getTechnicianName() {
    let techObj = {
      orgId: this.orgId,
    };
    return this.http.post("/api/getTechniciansName", techObj).subscribe(
      (res) => {
        res.json();
        this.ListTechnicianName = res.json();
        //console.log("this.ListTechnicianName " + this.ListTechnicianName);
      },
      (err) => {
        this.msgtext = "Unable to load the Technicians Value";
        this.getWarningFunction(this.msgtext);
      }
    );
  }

  // backToMyForm() {
  //      this.router.navigate(['myform']);
  //    }

  getAllDetailsFromCheckListMaster() {
    let reqService = {
      orgId: this.orgId,
    };
    return this.http.post("/api/getServiceTypedetails", reqService).subscribe(
      (res) => {
        this.ListOfCheckListMaster = res.json();
        let pusharr = [];
        for (let i = 0; i < this.ListOfCheckListMaster.length; i++) {
          pusharr.push({
            value: this.ListOfCheckListMaster[i]._id,
            label: this.ListOfCheckListMaster[i].servicetype,
          });
        }
        this.ListOfCheckListMasterdropdown = pusharr;
      },
      (err) => {
        if (err.status != 200) {
          this.msgtext = "Unable to load the Value";
          this.getWarningFunction(this.msgtext);
        }
      }
    );
  }

  Inputbranch(value) {
    if (value == null || value == undefined || value == "") {
      this.brancherr = true;
    } else {
      this.brancherr = false;
    }
    if (
      this.mclocation == "" ||
      this.mclocation == null ||
      this.mclocation == undefined
    ) {
      this.branch = "";
      this.BranchPlaceholder = "CHOOSE THE BRANCH";
      $("#branchlocation").val("");
      alert("please choose the Machine location first");
    } else {
      let loglatArr = [];
      for (let i = 0; i < this.Listbranchdetails.length; i++) {
        if (this.Listbranchdetails[i]._id == value) {
          this.Listbranchdetails[i].latitude;
          this.Listbranchdetails[i].longitude;
          loglatArr.push(
            this.Listbranchdetails[i].latitude +
              "," +
              this.Listbranchdetails[i].longitude
          );
        }
      }

      let distinationobj = {
        lat_and_lang: this.latitude + "," + this.longitude,
        destinations: loglatArr.join("|").toString(),
      };
      return this.http
        .post(
          "https://still.alshirawi.com/highmessaging/getAllGoogleMapsWebserviceDetails",
          distinationobj
        )
        .subscribe((res) => {
          let response = res.json();
          this.seconds = response.rows[0].elements[0].duration.value;
          console.log("durationValue " + this.seconds);
          this.secToMin = Math.floor(this.seconds / 60); //checking into mins
          this.secToHours = 0;
          this.secToHours_Remainder = 0;
          this.Hoursprice = 0;
          this.FinalDuration = 0;
          this.Price = 0;
          this.travelhours = 0;
          this.Finalmins = 0;
          this.minstravel = 0;
          if (this.secToMin >= 60) {
            this.secToHours = Math.floor(this.seconds / 3600);
            this.travelhours = this.secToHours;
            // this.Hoursprice = this.secToHours*165;
            this.Hoursprice = this.TravelcostValue * this.secToHours;
            this.secToHours_Remainder = this.seconds % 3600;
            if (this.secToHours_Remainder <= 1800) {
              this.Price = this.Hoursprice + this.TravelcostValue / 2;
              this.minstravel = 0.5;
            } else if (
              this.secToHours_Remainder > 1800 &&
              this.secToHours_Remainder <= 2700
            ) {
              this.Price = this.Hoursprice + (this.TravelcostValue * 3) / 4;
              this.minstravel = 0.75;
            } else if (
              this.secToHours_Remainder > 2700 &&
              this.secToHours_Remainder < 3600
            ) {
              // this.Price=this.Hoursprice+165;
              this.Price = this.Hoursprice + this.TravelcostValue;
              this.travelhours = this.travelhours + 1;
            }
          } else {
            if (this.secToMin <= 30) {
              this.FinalDuration = 30;
              this.minstravel = 0.5;
            } else if (this.secToMin > 30 && this.secToMin <= 45) {
              this.FinalDuration = 45;
              this.minstravel = 0.75;
            } else if (this.secToMin > 45) {
              this.FinalDuration = 60;
              this.travelhours = this.travelhours + 1;
            }
          }

          if (this.FinalDuration == 30) {
            this.Price = this.TravelcostValue / 2;
          } else if (this.FinalDuration == 45) {
            this.Price = (this.TravelcostValue * 3) / 4;
          } else if (this.FinalDuration == 60) {
            this.Price = this.TravelcostValue;
          }

          this.Finalmins = this.travelhours + this.minstravel;
          for (
            let sr = this.serviceScheduleNumber - 1;
            sr < this.ListOfSecondFields.length;
            sr++
          ) {
            this.ListOfSecondFields[sr].travel_Cost = (this.Price * 2).toFixed(
              2
            );

            this.ListOfSecondFields[sr].travel_hour = this.Finalmins * 2;
          }
        });
    }
  }

  getAllPreventiveMaintenanceDetails() {
    this.loading = true;
    let reqPMS = {
      orgId: this.orgId,
    };
    return this.http
      .post("/api/getAllPreventiveMaintenanceDetails", reqPMS)
      .subscribe(
        (res) => {
          let CustomerArr = [];
          let SerialNumberDataArr = [];
          this.ListOfPreventiveMaintenanceDetails = res.json();
          for (
            let s = 0;
            s < this.ListOfPreventiveMaintenanceDetails.length;
            s++
          ) {
            SerialNumberDataArr.push(
              this.ListOfPreventiveMaintenanceDetails[s].serial_Number
            );
          }
          let UniqueSerialNumber = SerialNumberDataArr.filter(function (
            item,
            i,
            ar
          ) {
            return ar.indexOf(item) === i;
          });
          let FinalUniqueSerialNumber = [];
          for (let su = 0; su < UniqueSerialNumber.length; su++) {
            let obj = {
              label: UniqueSerialNumber[su],
              value: UniqueSerialNumber[su],
            };
            FinalUniqueSerialNumber.push(obj);
          }
          this.ListSerialNumberOption = FinalUniqueSerialNumber;
          this.loading = false;
          this.getTechnicianName();
          this.getemiratesdetails();
          this.getbranchdetails();
          this.getTravelCostvalues();
          this.getAllSublocalitydetails();
          this.getAllCustomerMasterDetails();
          this.getAllDetailsFromCheckListMaster();
          this.NewSerialNumber = this.route.params["value"].serialNumber;
          if (
            this.NewSerialNumber == "" ||
            this.NewSerialNumber == undefined ||
            this.NewSerialNumber == null
          ) {
          } else {
            this.serialnumber = this.NewSerialNumber;
            this.InputFieldCheck(this.NewSerialNumber);
          }
        },
        (err) => {
          this.getTechnicianName();
          this.getemiratesdetails();
          this.getbranchdetails();
          this.getTravelCostvalues();
          this.getAllSublocalitydetails();
          this.getAllCustomerMasterDetails();
          this.getAllDetailsFromCheckListMaster();
          this.NewSerialNumber = this.route.params["value"].serialNumber;
          if (
            this.NewSerialNumber == "" ||
            this.NewSerialNumber == undefined ||
            this.NewSerialNumber == null
          ) {
          } else {
            this.serialnumber = this.NewSerialNumber;
            this.InputFieldCheck(this.NewSerialNumber);
          }
          // this.spinner.hide();
          this.loading = false;
          if (err.status != 200) {
            this.msgtext = "Unable to load the PMS Value";
            this.getWarningFunction(this.msgtext);
          }
        }
      );
  }

  InputFieldCheck(getValue) {
    if (
      this.serialnumber == "" ||
      this.serialnumber == undefined ||
      this.serialnumber == null
    ) {
      this.isValid = false;
      this.postponedatevalid = true;
      this.serialnumber = "";
      this.getEmptyAllField();
    } else {
      this.isValid = true;
      this.postponedatevalid = false;
      this.serialNumbercounterr = false;
      this.serialnumber = getValue;
      let serialObj = {
        serialNumber: this.serialnumber,
        orgId: this.orgId,
      };
      return this.http
        .post("/api/CheckSerialNumberExistOrNot", serialObj)
        .subscribe(
          (res) => {
            let SerialResponse = res.json();
            this.mclocation = "";
            this.branch = "";
            this.getListClientdetails = SerialResponse;
            if (SerialResponse.length > 0) {
              let SerialNumberCount = SerialResponse.length - 1;
              this.noofService =
                this.getListClientdetails[SerialNumberCount].no_Of_Service;
              this.serviceScheduleNumber =
                this.getListClientdetails[SerialNumberCount].serviceScheduleDay;

              this.clientName =
                this.getListClientdetails[SerialNumberCount].client_Name;
              for (let i = 0; i < this.ListOfCustomermaster.length; i++) {
                if (
                  this.ListOfCustomermaster[i]._id == parseInt(this.clientName)
                ) {
                  this.CustomerName =
                    this.ListOfCustomermaster[i].customer_Name;
                }
              }
              this.preventiveId =
                this.getListClientdetails[SerialNumberCount]._id;
              //this.clientName = this.CustomerName;
              this.serialnumber =
                this.getListClientdetails[SerialNumberCount].serial_Number;
              this.mclocation =
                this.getListClientdetails[SerialNumberCount].mcLocation;
              this.clientPhonenumber =
                this.getListClientdetails[SerialNumberCount].phone_Number;
              this.email = this.getListClientdetails[SerialNumberCount].email;
              // this.emirates=this.getListClientdetails[SerialNumberCount].emiratesId;

              // this.ListEmiratesdetails.forEach(Emirate => {
              //   if(Emirate._id==this.emirates){
              //     this.emiratesedit=Emirate.emirates.toUpperCase();
              //   }
              // });
              // this.getAllSublocalitydetails();
              // this.subLocality=this.getListClientdetails[SerialNumberCount].subLocalityId;
              // this.ListofSublocality.forEach(element=>{
              //   if(element._id==this.subLocality){
              //     this.subLocalityedit=element.sublocation.toUpperCase();
              //   }
              // })

              this.emirates =
                this.getListClientdetails[
                  SerialNumberCount
                ].emiratesId.toString();
              for (let i = 0; i < this.emiratesOptions.length; i++) {
                if (this.emirates == this.emiratesOptions[i].value) {
                  this.emiratesedit = this.emiratesOptions[i].label;
                }
              }
              this.getAllSublocalitydetails();
              this.subLocality =
                this.getListClientdetails[
                  SerialNumberCount
                ].subLocalityId.toString();
              for (let i = 0; i < this.subLocalityOptions.length; i++) {
                if (this.subLocality == this.subLocalityOptions[i].value) {
                  this.subLocalityedit = this.subLocalityOptions[i].label;
                }
              }
              this.make = this.getListClientdetails[SerialNumberCount].make;
              this.reqMakeId =
                this.getListClientdetails[SerialNumberCount].make;
              this.getmakedetails();
              this.model = this.getListClientdetails[SerialNumberCount].model;
              this.reqmodelId =
                this.getListClientdetails[SerialNumberCount].model;
              this.getmodeldetails();
              this.hmrHours = this.getListClientdetails[SerialNumberCount].hmr;
              this.technicianName =
                this.getListClientdetails[SerialNumberCount].technician_Name;
              this.lastServiceType =
                this.getListClientdetails[SerialNumberCount].last_Service_Type;
              this.lastServiceHour =
                this.getListClientdetails[SerialNumberCount].last_Service_Hours;
              this.yearofmanufacturer =
                this.getListClientdetails[
                  SerialNumberCount
                ].year_Of_manufacturer;
              this.branch = this.getListClientdetails[SerialNumberCount].branch;
              this.originalEndDate =
                this.getListClientdetails[SerialNumberCount].original_end_date;

              for (let i = 0; i < this.Listbranchdetails.length; i++) {
                if (this.Listbranchdetails[i]._id == this.branch) {
                  this.BranchPlaceholder =
                    this.Listbranchdetails[i].branchAlias;
                }
              }
              this.serviceContractOffered =
                this.getListClientdetails[
                  SerialNumberCount
                ].service_Contract_Offered;
              this.contractReference =
                this.getListClientdetails[SerialNumberCount].contract_Reference;
              this.serviceRemainderDays =
                this.getListClientdetails[SerialNumberCount].remainderday;
              this.intervalofservice =
                this.getListClientdetails[
                  SerialNumberCount
                ].days_Interval_Of_Service;
              this.sst = this.getListClientdetails[SerialNumberCount].sst;
              this.startdate =
                this.getListClientdetails[SerialNumberCount].start_Date;
              this.endDate =
                this.getListClientdetails[SerialNumberCount].end_Date;
              this.NoOfServiceContractYear =
                this.getListClientdetails[
                  SerialNumberCount
                ].noofServiceContractYear;
              this.ListOfFields =
                this.getListClientdetails[SerialNumberCount].Sparedetails;
              this.ListOfSecondFields =
                this.getListClientdetails[SerialNumberCount].Servicedetails;
              this.pdfSrc =
                this.getListClientdetails[SerialNumberCount].fileName;
              if (this.intervalofservice < 15) {
                this.numberofDayDisable = this.intervalofservice;
              } else {
                this.numberofDayDisable = 15;
              }

              for (let i = 0; i < this.ListOfSecondFields.length; i++) {
                if (this.serviceScheduleNumber == 1) {
                  this.ListOfSecondFields[i].mindate = moment(
                    new Date(this.ListOfSecondFields[i].date)
                  )
                    .subtract(0, "days")
                    .format("YYYY-MM-DD");
                  this.ListOfSecondFields[i].maxdate = moment(
                    new Date(this.ListOfSecondFields[i].date)
                  )
                    .add(this.numberofDayDisable, "days")
                    .format("YYYY-MM-DD");
                } else {
                  this.ListOfSecondFields[i].mindate = moment(
                    new Date(this.ListOfSecondFields[i].date)
                  )
                    .subtract(this.numberofDayDisable, "days")
                    .format("YYYY-MM-DD");
                  this.ListOfSecondFields[i].maxdate = moment(
                    new Date(this.ListOfSecondFields[i].date)
                  )
                    .add(this.numberofDayDisable, "days")
                    .format("YYYY-MM-DD");
                }
              }

              this.serviceCarriedOutDate =
                this.ListOfSecondFields[this.serviceScheduleNumber - 1].date;
              this.previousServiceDateSnapshot = this.serviceCarriedOutDate;
              if (this.serviceScheduleNumber == this.noofService) {
              } else {
                this.nextServiceType =
                  this.ListOfSecondFields[
                    this.serviceScheduleNumber
                  ].service_Type;
              }
              this.contractLevel =
                this.getListClientdetails[SerialNumberCount].contractLevel;
              this.nextServiceRemainderDays =
                this.getListClientdetails[SerialNumberCount].remainderday;
              if (this.noofService == this.serviceScheduleNumber) {
                let statusObj = {
                  pmId: this.preventiveId,
                  serialNumber: this.serialnumber,
                };
                return this.http
                  .post("/api/serviceStatusChecking_serviceFormAPI", statusObj)
                  .subscribe((res) => {
                    let response = res.json();
                    if (
                      response[response.length - 1].service_Scheduler_Number ==
                        this.noofService &&
                      response[response.length - 1].status == 1
                    ) {
                      this.lastServiceStatus = true;
                    } else {
                      this.lastServiceStatus = false;
                    }
                  });
              } else {
              }
            } else {
              this.getEmptyAllField();
              //this.serialnumber = getValue.trim();
            }
          },
          (err) => {
            this.getEmptyAllField();
            this.msgtext = "Unable to load Serial Number details";
            this.getWarningFunction(this.msgtext);
          }
        );
    }
  }

  _keyPress(event: any) {
    const pattern = /[0-9\.\ ]/;
    let inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  getmakedetails() {
    let makeObj = {
      makeId: this.reqMakeId,
      orgId: this.orgId,
    };
    return this.http.post("/api/getMakedetailsBasedOnId", makeObj).subscribe(
      (res) => {
        let response = res.json();
        if (response.length > 0) {
          this.makeName = response[0].make.toUpperCase();
        }
      },
      (err) => {
        this.msgtext = "Unable to load Make";
        this.getWarningFunction(this.msgtext);
      }
    );
  }
  getmodeldetails() {
    let modelObj = {
      modelId: this.reqmodelId,
      orgId: this.orgId,
    };
    return this.http.post("/api/getModeldetailsBasedOnId", modelObj).subscribe(
      (res) => {
        let response = res.json();
        if (response.length > 0) {
          this.modelName = response[0].model.toUpperCase();
        }
      },
      (err) => {
        this.msgtext = "Unable to load Model";
        this.getWarningFunction(this.msgtext);
      }
    );
  }

  onchangehmr(value, index) {
    for (let i = index; i < this.ListOfSecondFields.length; i++) {
      if (i == index) {
      } else {
        this.ListOfSecondFields[i].hmr =
          parseInt(this.ListOfSecondFields[i - 1].hmr) + 250;
      }
    }
  }

  onchangeSST(value, index) {
    for (let i = index; i < this.ListOfSecondFields.length; i++) {
      if (i == index) {
      } else {
        this.ListOfSecondFields[i].sst =
          parseInt(this.ListOfSecondFields[i - 1].sst) + 250;
      }
    }
  }

  nextServiceTypeChange(value) {
    this.ListOfSecondFields[this.serviceScheduleNumber].servicetype = value;
    let getNewValues = [];
    getNewValues = this.ListOfSecondFields;
    if (value == null || value == undefined) {
      this.isValid = false;
    } else {
      this.isValid = true;
    }
    //this.ListOfSecondFields = [];
    //this.ListOfSecondFields = getNewValues;
    //this.serviceTypeDetails(value, this.serviceScheduleNumber);
  }

  serviceTypeDetails(service, IndexCount) {
    let sparePrice = 0;
    let consumablePrice = 0;
    this.ListOfSecondFields[IndexCount].consumables = 0;
    this.ListOfSecondFields[IndexCount].spare_Cost = 0;
    for (let s = 0; s < this.ListOfCheckListMaster.length; s++) {
      if (this.ListOfCheckListMaster[s]._id == parseInt(service)) {
        service = this.ListOfCheckListMaster[s].servicetype;
      }
    }
    for (let i = 0; i < this.ListOfFields.length; i++) {
      for (let k = 0; k < this.ListOfFields[i].service_Type.length; k++) {
        if (
          this.ListOfFields[i].service_Type[k].service == service &&
          this.ListOfFields[i].service_Type[k].check == true &&
          this.ListOfFields[i].cost_Type == "SPARE COST"
        ) {
          sparePrice += parseInt(this.ListOfFields[i].selling_Price);
          this.ListOfSecondFields[IndexCount].spare_Cost = sparePrice;
        } else if (
          this.ListOfFields[i].service_Type[k].service == service &&
          this.ListOfFields[i].service_Type[k].check == true &&
          this.ListOfFields[i].cost_Type == "CONSUMABLES"
        ) {
          consumablePrice += parseInt(this.ListOfFields[i].selling_Price);
          this.ListOfSecondFields[IndexCount].consumables = consumablePrice;
        }
      }
    }

    let labourcostobj = {
      makeId: this.reqMakeId,
      modelId: this.reqmodelId,
      serviceType: this.ListOfSecondFields[IndexCount].service_Type,
      orgId: this.orgId,
    };

    return this.http
      .post("/api/getLabourCostdetailsFORPMS", labourcostobj)
      .subscribe(
        (res) => {
          let getresponse = res.json();
          if (getresponse.length > 0) {
            this.ListOfSecondFields[IndexCount].labour_Cost =
              getresponse[0].labourCost * getresponse[0].labourhours;
            this.ListOfSecondFields[IndexCount].labour_hour =
              getresponse[0].labourhours;
          } else {
            this.ListOfSecondFields[IndexCount].labour_hour = 0;
            this.ListOfSecondFields[IndexCount].labour_Cost = 0;
          }
        },
        (err) => {
          this.msgtext = "Unable to find Labour cost";
          this.getWarningFunction(this.msgtext);
        }
      );
  }

  changedate(date, IndexCount) {
    let isLastService =
      parseInt(this.serviceScheduleNumber) >= parseInt(this.noofService);
    let nextService =
      this.ListOfSecondFields[parseInt(this.serviceScheduleNumber)];
    if (isLastService) {
      this.nextServiceChecking = 0;
      this.isValid = true;
    } else if (
      nextService == undefined ||
      nextService.date == "" ||
      nextService.date == null ||
      nextService.date == undefined
    ) {
      this.nextServiceChecking = 1;
    } else {
      this.nextServiceChecking = 0;
      this.isValid = true;
    }
    this.serviceCarriedOutDate = date;
    let k = 0;
    for (var i = IndexCount; i < this.ListOfSecondFields.length; i++) {
      let addValue = this.intervalofservice * k;
      this.ListOfSecondFields[i].date = moment(new Date(date))
        .add(addValue, "days")
        .format("YYYY-MM-DD");
      k++;
    }

    // if(IndexCount > 1) {
    // if(this.ListOfSecondFields[this.serviceScheduleNumber-2].date > this.ListOfSecondFields[this.serviceScheduleNumber-1].date) {
    //   alert('date should be greater than previous service date');
    //   this.ListOfSecondFields[this.serviceScheduleNumber-1].date = '';
    // } else
    if (
      this.ListOfSecondFields[this.ListOfSecondFields.length - 1].date >
        this.endDate ||
      this.ListOfSecondFields[this.ListOfSecondFields.length - 1].date <
        this.startdate
    ) {
      $("html, body").animate({ scrollTop: 0 }, "fast");
      for (var i = IndexCount; i < this.ListOfSecondFields.length; i++) {
        this.ListOfSecondFields[i].date = "";
      }

      this.newserialNumber = this.serialnumber;
      this.newstartdate = this.startdate;
      this.newenddate = this.endDate;
      $("#alertPopup").modal("show");
    }
    // }
  }

  serviceDate(date) {
    console.log(this.serviceScheduleNumber);
    for (
      var i = this.serviceScheduleNumber - 1;
      i < this.ListOfSecondFields.length;
      i++
    ) {
      let addValue = this.intervalofservice * i;
      this.ListOfSecondFields[i].date = moment(new Date(date))
        .add(addValue, "days")
        .format("YYYY-MM-DD");
    }
  }

  nextServiceRemainder(value) {
    let isLastService =
      parseInt(this.serviceScheduleNumber) >= parseInt(this.noofService);
    let nextService =
      this.ListOfSecondFields[parseInt(this.serviceScheduleNumber)];
    if (isLastService) {
      this.nextServiceChecking = 0;
      this.isValid = true;
    } else if (
      nextService == undefined ||
      nextService.date == "" ||
      nextService.date == null ||
      nextService.date == undefined
    ) {
      this.FinalCount = parseInt(this.serviceScheduleNumber) + 1;
      alert("pls mention " + this.FinalCount + " Service date");
      this.nextServiceChecking = 1;
    } else {
      this.nextServiceChecking = 0;
      this.isValid = true;
    }
  }

  cancel() {
    $("#ServiceMismatch").modal("hide");
    // this.ServiceMismatch.hide();
  }

  prepone() {
    $("#ServiceMismatch").modal("hide");
    this.router.navigate([
      "node/postPonedForm",
      {
        orgId: this.orgId,
        userId: this.userId,
        serialNumber: this.serialnumber,
        type: "servicePrepone",
      },
    ]);
  }

  postpone() {
    $("#ServiceMismatch").modal("hide");
    this.router.navigate([
      "node/postPonedForm",
      {
        orgId: this.orgId,
        userId: this.userId,
        serialNumber: this.serialnumber,
        type: "servicePostpone",
      },
    ]);
  }

  Submit() {
    debugger;
    if (this.serviceCompletion == false) {
      // this.spinner.show();
      this.loading = true;
      if (
        this.serialnumber == "" ||
        this.serialnumber == undefined ||
        this.serialnumber == null
      ) {
        this.isValid = false;
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        // this.spinner.hide();
        this.loading = false;
      } else if (
        this.ListOfSecondFields[parseInt(this.serviceScheduleNumber) - 1].hmr ==
          "" ||
        this.ListOfSecondFields[parseInt(this.serviceScheduleNumber) - 1].hmr ==
          undefined ||
        this.ListOfSecondFields[parseInt(this.serviceScheduleNumber) - 1].hmr ==
          null ||
        this.ListOfSecondFields[parseInt(this.serviceScheduleNumber) - 1]
          .date == "" ||
        this.ListOfSecondFields[parseInt(this.serviceScheduleNumber) - 1]
          .date == undefined ||
        this.ListOfSecondFields[parseInt(this.serviceScheduleNumber) - 1]
          .date == null ||
        this.ListOfSecondFields[parseInt(this.serviceScheduleNumber) - 1]
          .service_Type == undefined ||
        this.ListOfSecondFields[parseInt(this.serviceScheduleNumber) - 1]
          .service_Type == null ||
        this.ListOfSecondFields[parseInt(this.serviceScheduleNumber) - 1]
          .service_Type == "" ||
        this.ListOfSecondFields[parseInt(this.serviceScheduleNumber) - 1]
          .labour_Cost == undefined ||
        this.ListOfSecondFields[parseInt(this.serviceScheduleNumber) - 1]
          .labour_Cost == "" ||
        this.ListOfSecondFields[parseInt(this.serviceScheduleNumber) - 1]
          .labour_Cost == null ||
        this.ListOfSecondFields[parseInt(this.serviceScheduleNumber) - 1]
          .travel_Cost == null ||
        this.ListOfSecondFields[parseInt(this.serviceScheduleNumber) - 1]
          .travel_Cost == "" ||
        this.ListOfSecondFields[parseInt(this.serviceScheduleNumber) - 1]
          .consumables == undefined ||
        this.ListOfSecondFields[parseInt(this.serviceScheduleNumber) - 1]
          .consumables == undefined ||
        this.ListOfSecondFields[parseInt(this.serviceScheduleNumber) - 1]
          .consumables == undefined
      ) {
        this.isValid = true;
        // this.spinner.hide();
        this.loading = false;
        let dd = parseInt(this.serviceScheduleNumber);
        alert("pls enter " + this.serviceScheduleNumber + " Service details");
      } else if (this.nextServiceChecking == 1) {
        this.isValid = false;
        // this.spinner.hide();
        this.loading = false;
        alert("pls mention " + this.FinalCount + " Service date");
      } else {
        let reqObj = {
          PMId: this.preventiveId,
          client_Name: this.clientName,
          serial_Number: this.serialnumber,
          mcLocation: this.mclocation,
          no_Of_Service: this.noofService,
          start_Date: this.startdate,
          end_Date: this.endDate,
          make: this.make,
          days_Interval_Of_Service: this.intervalofservice,
          model: this.model,
          hmr: this.hmrHours,
          sst: this.sst,
          technician_Name: this.technicianName,
          last_Service_Type: this.lastServiceType,
          last_Service_Hours: this.lastServiceHour,
          year_Of_manufacturer: this.yearofmanufacturer,
          branch: this.branch,
          service_Contract_Offered: this.serviceContractOffered,
          contract_Reference: this.contractReference,
          phone_Number: this.clientPhonenumber,
          email: this.email,
          remainderday: this.serviceRemainderDays,
          noofServiceContractYear: this.NoOfServiceContractYear,
          contractLevel: this.contractLevel,
          SpareValues: this.ListOfFields,
          Servicevalues: this.ListOfSecondFields,
          locality: this.locality,
          fileName: this.pdfSrc,
          emirates: this.emirates,
          subLocality: this.subLocality,
          updated_By: this.userId,
          updated_Date: moment(new Date()).utc().format("YYYY:MM:DD h:mm:ss"),
        };
        return this.http
          .post("/api/updatePMSContractDetails", reqObj)
          .subscribe(
            (res) => {
              let days = this.nextServiceRemainderDays;
              let serviceDate =
                this.ListOfSecondFields[
                  parseInt(this.serviceScheduleNumber) - 1
                ].date;
              let Remainder = moment(new Date(serviceDate))
                .subtract(days, "Days")
                .format("YYYY-MM-DD");
              let reqObj = {
                pm_Id: this.preventiveId,
                serialNumber: this.serialnumber,
                schedularNumber: this.serviceScheduleNumber,
                service_Scheduler_Number: this.serviceScheduleNumber,
                service_CarriedOut_Date:
                  this.ListOfSecondFields[this.serviceScheduleNumber - 1].date,
                next_Service_Remainder_day: this.nextServiceRemainderDays,
                next_Service_Type: this.nextServiceType,
                Remainderdate: Remainder,
                service_Type:
                  this.ListOfSecondFields[this.serviceScheduleNumber - 1]
                    .service_Type,
                contractLevel: this.contractLevel,
                mcLocation: this.mclocation,
                locality: this.locality,
                branch: this.branch,
                Servicedetails: this.ListOfSecondFields,
                orgId: this.orgId,
                created_By: this.userId,
                created_Date: moment(new Date())
                  .utc()
                  .format("YYYY:MM:DD h:mm:ss"),
              };

              return this.http
                .post("/api/UpdateExistingService", reqObj)
                .subscribe(
                  (res) => {
                    res.json();
                    let nextSeviceType;
                    let prevServiceType;
                    let ReqObj = {};
                    this.loading = false;
                    for (
                      let i = 0;
                      i < this.ListOfCheckListMaster.length;
                      i++
                    ) {
                      if (
                        this.ListOfSecondFields[
                          parseInt(this.serviceScheduleNumber)
                        ].service_Type == this.ListOfCheckListMaster[i]._id
                      ) {
                        nextSeviceType =
                          this.ListOfCheckListMaster[i].servicetype;
                      }
                      if (
                        this.ListOfSecondFields[
                          parseInt(this.serviceScheduleNumber) - 1
                        ].service_Type == this.ListOfCheckListMaster[i]._id
                      ) {
                        prevServiceType =
                          this.ListOfCheckListMaster[i].servicetype;
                      }
                    }
                    ReqObj = {
                      SCHEDULE_DATE: this.serviceCarriedOutDate,
                      userId: this.technicianName,
                      MachineNumber: this.serialnumber,
                      customerName: this.CustomerName,
                      phoneNumber: this.clientPhonenumber,
                      machineMake: this.makeName,
                      machineModel: this.modelName,
                      PMId: this.preventiveId,
                      RemainderDate: Remainder,
                      CREATED_DATE: moment(new Date()).format("YYYY-MM-DD"),
                      lastserviceType: prevServiceType,
                      lastserviceHmr:
                        this.ListOfSecondFields[
                          parseInt(this.serviceScheduleNumber) - 1
                        ].hmr,
                      nextserviceHmr:
                        this.ListOfSecondFields[
                          parseInt(this.serviceScheduleNumber)
                        ].hmr,
                      nextservicetype: nextSeviceType,
                      nextServicedate:
                        this.ListOfSecondFields[
                          parseInt(this.serviceScheduleNumber)
                        ].date,
                      lastServiceDate:
                        this.ListOfSecondFields[
                          parseInt(this.serviceScheduleNumber) - 1
                        ].date,
                      orgId: this.orgId,
                      original_end_date: this.originalEndDate,
                      created_By: this.userId,
                    };

                    return this.http
                      .post("/api/PMSNotifications", ReqObj)
                      .subscribe(
                        (res) => {
                          $("#currentDetails").modal("show");

                          // this.currentDetails.options = {
                          //   showButtons: false, // You can hide this in case you want to use custom
                          //   color: "#4180ab",
                          //   header: "Service Updation Form"
                          // };
                          // this.currentDetails.show(this.currentDetails.options);
                          this.loading = false;
                          this.router.navigate([
                            "node/serviceContract",
                            { orgId: this.orgId, userId: this.userId },
                          ]);
                        },
                        (err) => {
                          console.log(err);
                        }
                      );
                  },
                  (err) => {
                    console.log(err);
                  }
                );
              //this.getEmptyAllField();
            },
            (err) => {
              // this.spinner.hide();
              this.loading = false;
              this.msgtext = "Unable to UpdateServiceDetails";
              this.getWarningFunction(this.msgtext);
            }
          );
      }
    } else if (this.serviceCompletion == true) {
      if (this.serviceScheduleNumber == this.noofService) {
        // this.spinner.show();
        //this.loading=true;
        if (
          this.serialnumber == "" ||
          this.serialnumber == undefined ||
          this.serialnumber == null
        ) {
          this.isValid = false;
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
          // this.spinner.hide();
          this.loading = false;
        } else if (this.serviceUpdateType == "prepost") {
          if (
            this.serviceCarriedOutDate !=
            moment(new Date()).format("YYYY-MM-DD")
          ) {
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
            $("#ServiceMismatch").modal("show");
            // this.ServiceMismatch.options = {
            //   showButtons: false, // You can hide this in case you want to use custom
            //   color: "#4180ab",
            //   header: "Service Updation Form"
            // };
            // this.ServiceMismatch.show(this.ServiceMismatch.options);
            //alert('service carried out date mismatch');
            // this.spinner.hide();
            this.loading = false;
          }
        } else if (
          this.ListOfSecondFields[parseInt(this.serviceScheduleNumber) - 1]
            .hmr == "" ||
          this.ListOfSecondFields[parseInt(this.serviceScheduleNumber) - 1]
            .hmr == undefined ||
          this.ListOfSecondFields[parseInt(this.serviceScheduleNumber) - 1]
            .hmr == null ||
          this.ListOfSecondFields[parseInt(this.serviceScheduleNumber) - 1]
            .date == "" ||
          this.ListOfSecondFields[parseInt(this.serviceScheduleNumber) - 1]
            .date == undefined ||
          this.ListOfSecondFields[parseInt(this.serviceScheduleNumber) - 1]
            .date == null ||
          this.ListOfSecondFields[parseInt(this.serviceScheduleNumber) - 1]
            .service_Type == undefined ||
          this.ListOfSecondFields[parseInt(this.serviceScheduleNumber) - 1]
            .service_Type == null ||
          this.ListOfSecondFields[parseInt(this.serviceScheduleNumber) - 1]
            .service_Type == "" ||
          this.ListOfSecondFields[parseInt(this.serviceScheduleNumber) - 1]
            .labour_Cost == undefined ||
          this.ListOfSecondFields[parseInt(this.serviceScheduleNumber) - 1]
            .labour_Cost == "" ||
          this.ListOfSecondFields[parseInt(this.serviceScheduleNumber) - 1]
            .labour_Cost == null ||
          this.ListOfSecondFields[parseInt(this.serviceScheduleNumber) - 1]
            .travel_Cost == null ||
          this.ListOfSecondFields[parseInt(this.serviceScheduleNumber) - 1]
            .travel_Cost == "" ||
          this.ListOfSecondFields[parseInt(this.serviceScheduleNumber) - 1]
            .consumables == undefined ||
          this.ListOfSecondFields[parseInt(this.serviceScheduleNumber) - 1]
            .consumables == undefined ||
          this.ListOfSecondFields[parseInt(this.serviceScheduleNumber) - 1]
            .consumables == undefined
        ) {
          this.isValid = true;
          // this.spinner.hide();
          this.loading = false;
          let dd = parseInt(this.serviceScheduleNumber);
          alert("pls enter " + this.serviceScheduleNumber + " Service details");
        } else if (this.nextServiceChecking == 1) {
          this.isValid = false;
          // this.spinner.hide();
          this.loading = false;
          alert("pls mention " + this.FinalCount + " Service date");
        } else {
          let currentServiceIndex = parseInt(this.serviceScheduleNumber) - 1;
          console.log("[ServiceContractDebug] last-service-before-complete-submit", {
            serialNumber: this.serialnumber,
            preventiveId: this.preventiveId,
            serviceScheduleNumber: this.serviceScheduleNumber,
            noofService: this.noofService,
            previousServiceDate: this.previousServiceDateSnapshot,
            serviceCarriedOutDate: this.serviceCarriedOutDate,
            currentServiceRow:
              this.ListOfSecondFields[currentServiceIndex],
            allServiceDates: this.ListOfSecondFields.map((service, index) => ({
              index: index + 1,
              date: service.date,
              hmr: service.hmr,
              serviceType: service.service_Type,
            })),
          });
          let updateObj = {
            pm_Id: this.preventiveId,
            updated_By: this.userId,
            updated_Date: moment(new Date()).utc().format("YYYY:MM:DD h:mm:ss"),
            Servicevalues: this.ListOfSecondFields,
          };
          console.log("[ServiceContractDebug] last-service-updateContractCompleted-payload", updateObj);
          return this.http
            .post("/api/updateContractCompleted", updateObj)
            .subscribe((res) => {
              let updateObj = {
                pm_Id: this.preventiveId,
                serialNumber: this.serialnumber,
                serviceCarriedOutDate: this.serviceCarriedOutDate,
                schedularNumber: this.serviceScheduleNumber,
                updated_By: this.userId,
                updated_Date: moment(new Date())
                  .utc()
                  .format("YYYY:MM:DD h:mm:ss"),
              };
              console.log("[ServiceContractDebug] last-service-UpdatePrevoiusService-payload", updateObj);
              return this.http
                .post("/api/UpdatePrevoiusService", updateObj)
                .subscribe(
                  (res) => {
                    let response = res.json();
                    console.log("[ServiceContractDebug] last-service-after-complete-submit", {
                      response: response,
                      serialNumber: this.serialnumber,
                      preventiveId: this.preventiveId,
                      serviceScheduleNumber: this.serviceScheduleNumber,
                      serviceCarriedOutDate: this.serviceCarriedOutDate,
                      currentServiceRow:
                        this.ListOfSecondFields[parseInt(this.serviceScheduleNumber) - 1],
                    });
                    document.body.scrollTop = 0;
                    document.documentElement.scrollTop = 0;
                    this.getEmptyAllField();
                    this.serialnumber = "";
                    // this.spinner.hide();
                    this.loading = false;
                    $("#Newadd").modal("show");
                    // this.Newadd.options = {
                    //   showButtons: false, // You can hide this in case you want to use custom
                    //   color: "#4180ab",
                    //   header: "Service Updation Form"
                    // };
                    // this.Newadd.show(this.Newadd.options);
                    this.router.navigate([
                      "node/serviceContract",
                      { orgId: this.orgId, userId: this.userId },
                    ]);
                    // this.msgtext = "New Value Added Successfully";
                    // this.getSuccessFunction(this.msgtext);
                  },
                  (err) => {
                    // this.spinner.hide();
                    this.loading = false;
                    this.msgtext = "Unable to UpdatePrevoiusService";
                    this.getWarningFunction(this.msgtext);
                  }
                );
            });
        }
      } else {
        // this.spinner.show();
        //this.loading=true;
        if (
          this.serialnumber == "" ||
          this.serialnumber == undefined ||
          this.serialnumber == null
        ) {
          this.isValid = false;
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
          // this.spinner.hide();
          this.loading = false;
        } else if (
          this.ListOfSecondFields[parseInt(this.serviceScheduleNumber) - 1]
            .hmr == "" ||
          this.ListOfSecondFields[parseInt(this.serviceScheduleNumber) - 1]
            .hmr == undefined ||
          this.ListOfSecondFields[parseInt(this.serviceScheduleNumber) - 1]
            .hmr == null ||
          this.ListOfSecondFields[parseInt(this.serviceScheduleNumber) - 1]
            .date == "" ||
          this.ListOfSecondFields[parseInt(this.serviceScheduleNumber) - 1]
            .date == undefined ||
          this.ListOfSecondFields[parseInt(this.serviceScheduleNumber) - 1]
            .date == null ||
          this.ListOfSecondFields[parseInt(this.serviceScheduleNumber) - 1]
            .service_Type == undefined ||
          this.ListOfSecondFields[parseInt(this.serviceScheduleNumber) - 1]
            .service_Type == null ||
          this.ListOfSecondFields[parseInt(this.serviceScheduleNumber) - 1]
            .service_Type == "" ||
          this.ListOfSecondFields[parseInt(this.serviceScheduleNumber) - 1]
            .labour_Cost == undefined ||
          this.ListOfSecondFields[parseInt(this.serviceScheduleNumber) - 1]
            .labour_Cost == "" ||
          this.ListOfSecondFields[parseInt(this.serviceScheduleNumber) - 1]
            .labour_Cost == null ||
          this.ListOfSecondFields[parseInt(this.serviceScheduleNumber) - 1]
            .travel_Cost == null ||
          this.ListOfSecondFields[parseInt(this.serviceScheduleNumber) - 1]
            .travel_Cost == "" ||
          this.ListOfSecondFields[parseInt(this.serviceScheduleNumber) - 1]
            .consumables == undefined ||
          this.ListOfSecondFields[parseInt(this.serviceScheduleNumber) - 1]
            .consumables == undefined ||
          this.ListOfSecondFields[parseInt(this.serviceScheduleNumber) - 1]
            .consumables == undefined
        ) {
          this.isValid = true;
          // this.spinner.hide();
          this.loading = false;
          let dd = parseInt(this.serviceScheduleNumber);
          alert("pls enter " + this.serviceScheduleNumber + " Service details");
        } else if (this.nextServiceChecking == 1) {
          this.isValid = false;
          // this.spinner.hide();
          this.loading = false;
          alert("pls mention " + this.FinalCount + " Service date");
        } else {
          let days = this.nextServiceRemainderDays;
          let serviceDate =
            this.ListOfSecondFields[parseInt(this.serviceScheduleNumber)].date;
          let Remainder = moment(serviceDate)
            .subtract(days, "Days")
            .format("YYYY-MM-DD");
          let reqObj = {
            pm_Id: this.preventiveId,
            serialNumber: this.serialnumber,
            schedularNumber: this.serviceScheduleNumber,
            service_Scheduler_Number: this.serviceScheduleNumber,
            service_CarriedOut_Date:
              this.ListOfSecondFields[this.serviceScheduleNumber].date,
            next_Service_Remainder_day: this.nextServiceRemainderDays,
            next_Service_Type: this.nextServiceType,
            Remainderdate: Remainder,
            service_Type:
              this.ListOfSecondFields[this.serviceScheduleNumber].service_Type,
            contractLevel: this.contractLevel,
            mcLocation: this.mclocation,
            locality: this.locality,
            branch: this.branch,
            Servicedetails: this.ListOfSecondFields,
            orgId: this.orgId,
            created_By: this.userId,
            created_Date: moment(new Date()).utc().format("YYYY:MM:DD h:mm:ss"),
          };

          return this.http.post("/api/addServiceForm", reqObj).subscribe(
            (res) => {
              res.json();
              let nextSeviceType;
              let prevServiceType;
              let ReqObj = {};
              this.loading = false;
              for (let i = 0; i < this.ListOfCheckListMaster.length; i++) {
                if (
                  this.ListOfSecondFields[parseInt(this.serviceScheduleNumber)]
                    .service_Type == this.ListOfCheckListMaster[i]._id
                ) {
                  nextSeviceType = this.ListOfCheckListMaster[i].servicetype;
                }
                if (
                  this.ListOfSecondFields[
                    parseInt(this.serviceScheduleNumber) - 1
                  ].service_Type == this.ListOfCheckListMaster[i]._id
                ) {
                  prevServiceType = this.ListOfCheckListMaster[i].servicetype;
                }
              }
              ReqObj = {
                SCHEDULE_DATE: this.serviceCarriedOutDate,
                userId: this.technicianName,
                MachineNumber: this.serialnumber,
                customerName: this.CustomerName,
                phoneNumber: this.clientPhonenumber,
                machineMake: this.makeName,
                machineModel: this.modelName,
                PMId: this.preventiveId,
                RemainderDate: Remainder,
                CREATED_DATE: moment(new Date()).format("YYYY-MM-DD"),
                lastserviceType: prevServiceType,
                lastserviceHmr:
                  this.ListOfSecondFields[
                    parseInt(this.serviceScheduleNumber) - 1
                  ].hmr,
                nextserviceHmr:
                  this.ListOfSecondFields[parseInt(this.serviceScheduleNumber)]
                    .hmr,
                nextservicetype: nextSeviceType,
                nextServicedate:
                  this.ListOfSecondFields[parseInt(this.serviceScheduleNumber)]
                    .date,
                lastServiceDate:
                  this.ListOfSecondFields[
                    parseInt(this.serviceScheduleNumber) - 1
                  ].date,
                orgId: this.orgId,
                original_end_date: this.originalEndDate,
                created_By: this.userId,
              };

              return this.http.post("/api/PMSNotifications", ReqObj).subscribe(
                (res) => {
                  let updateObj = {
                    pm_Id: this.preventiveId,
                    serialNumber: this.serialnumber,
                    serviceCarriedOutDate: this.serviceCarriedOutDate,
                    schedularNumber: this.serviceScheduleNumber,
                    updated_By: this.userId,
                    updated_Date: moment(new Date())
                      .utc()
                      .format("YYYY:MM:DD h:mm:ss"),
                  };
                  return this.http
                    .post("/api/UpdatePrevoiusService", updateObj)
                    .subscribe(
                      (res) => {
                        let response = res.json();
                        document.body.scrollTop = 0;
                        document.documentElement.scrollTop = 0;
                        this.getEmptyAllField();
                        this.loading = false;
                        this.serialnumber = "";
                        this.router.navigate([
                          "node/serviceContract",
                          { orgId: this.orgId, userId: this.userId },
                        ]);
                        $("#Newadd").modal("show");
                        // this.Newadd.options = {
                        //   showButtons: false, // You can hide this in case you want to use custom
                        //   color: "#4180ab",
                        //   header: "Service Updation Form"
                        // };
                        // this.Newadd.show(this.Newadd.options);
                        // this.msgtext = "New Value Added Successfully";
                        // this.getSuccessFunction(this.msgtext);
                      },
                      (err) => {
                        // this.spinner.hide();
                        this.loading = false;
                        this.msgtext = "Unable to UpdatePrevoiusService";
                        this.getWarningFunction(this.msgtext);
                      }
                    );
                },
                (err) => {
                  // this.spinner.hide();
                  this.loading = false;
                  this.msgtext = "Unable to Add PMSNotifications";
                  this.getWarningFunction(this.msgtext);
                }
              );
            },
            (err) => {
              // this.spinner.hide();
              this.loading = false;
              this.msgtext = "Unable to Add addServiceForm";
              this.getWarningFunction(this.msgtext);
            }
          );
        }
      }
    }
  }

  // cdok() {
  //   this.currentDetails.hide();
  // }

  editdeatils() {
    this.numberlessthanremaindererr = false;
    if (
      this.intervalofservice == "" ||
      this.intervalofservice == undefined ||
      this.intervalofservice == null
    ) {
      alert("please select the serial Number");
    } else {
      this.newintervalofDays = this.intervalofservice;
      $("#contractDetailsEdit").modal("show");
      // this.contractDetailsEdit.options = {
      //   showButtons: false, // You can hide this in case you want to use custom
      //   color: "#4180ab",
      //   header: "Update Interval Of days"
      // };
      // this.contractDetailsEdit.show(this.contractDetailsEdit.options);
    }
  }

  newIntervalDay(value) {
    if (
      this.newintervalofDays == "" ||
      this.newintervalofDays == undefined ||
      this.newintervalofDays == null
    ) {
      this.intervalediterr = true;
    } else {
      this.intervalediterr = false;
      if (value < this.nextServiceRemainderDays) {
        this.numberlessthanremaindererr = true;
      } else {
        this.numberlessthanremaindererr = false;
      }
      for (
        let i = this.serviceScheduleNumber;
        i < this.ListOfSecondFields.length;
        i++
      ) {
        this.ListOfSecondFields[i].date = moment(
          new Date(this.ListOfSecondFields[i - 1].date)
        )
          .add(value, "days")
          .format("YYYY-MM-DD");
      }

      let count = parseInt(value) * parseInt(this.noofService);
      if (count > 365 * parseInt(this.NoOfServiceContractYear)) {
        let requiredNumber =
          (365 * parseInt(this.NoOfServiceContractYear)) / this.noofService;
        alert(
          "Interval Service days Should not greater than " +
            requiredNumber.toString().split(".")[0]
        );
        this.newintervalofDays = "";
        for (
          var i = this.serviceScheduleNumber;
          i < this.ListOfSecondFields.length;
          i++
        ) {
          this.ListOfSecondFields[i].date = "";
        }
      }
    }
  }

  editdata() {
    if (
      this.newintervalofDays == "" ||
      this.newintervalofDays == null ||
      this.newintervalofDays == undefined
    ) {
      this.intervalediterr = true;
    } else if (
      parseInt(this.newintervalofDays) < this.nextServiceRemainderDays
    ) {
      this.numberlessthanremaindererr = true;
    } else {
      // this.spinner.show();
      this.loading = true;
      let editreqObj = {
        Pm_ID: this.preventiveId,
        intervalOfdays: this.newintervalofDays,
        servicedetails: this.ListOfSecondFields,
      };
      return this.http
        .post("/api/updateContractIntervalDetails", editreqObj)
        .subscribe(
          (res) => {
            // this.spinner.hide();
            this.loading = false;
            let Response = res.json();
            alert("service contract update successfully done.");
            this.InputFieldCheck(this.serialnumber);
            $("#contractDetailsEdit").modal("hide");
            // this.contractDetailsEdit.hide();
          },
          (err) => {
            // this.spinner.hide();
            this.loading = false;
            this.msgtext = "Unable to update Interval Days";
            this.getWarningFunction(this.msgtext);
          }
        );
    }
  }

  reset() {
    this.getEmptyAllField();
  }

  getEmptyAllField() {
    this.ListOfSecondFields = [];
    this.serialnumber = "";
    this.ListOfSecondFields.push({
      hmr: "",
      date: "",
      serviceType: "",
      labourCost: "",
      labour_hour: "",
      SparesCost: "",
      travelCost: "",
      travel_hour: "",
      Consumables: "",
      disable: "No",
      mindate: "",
      maxdate: "",
    });
    this.serviceCompletion = false;
    this.clientName = "";
    this.emirates = "";
    this.subLocality = "";
    this.subLocalityedit = "SELECT A SUBLOCALITY";
    this.emiratesedit = "SELECT THE EMIRATES";
    this.BranchPlaceholder = "CHOOSE THE BRANCH";
    this.isValid = true;
    this.mclocation = "";
    this.noofService = "";
    this.startdate = "";
    this.endDate = "";
    this.make = "";
    this.intervalofservice = "";
    this.model = "";
    this.hmrHours = "";
    this.sst = "";
    this.technicianName = "";
    this.lastServiceType = "";
    this.lastServiceHour = "";
    this.yearofmanufacturer = "";
    this.branch = "";
    this.serviceContractOffered = "";
    this.contractReference = "";
    this.clientPhonenumber = "";
    this.email = "";
    this.serviceCarriedOutDate = "";
    this.nextServiceRemainderDays = "";
    this.nextServiceType = "";
    this.serviceScheduleNumber = "";
    this.serialNumbercounterr = false;
    this.serviceUpdateType = "dateUpdation";
  }

  otherserialNumber() {
    this.lastServiceStatus = false;
    this.getEmptyAllField();
  }

  getWarningFunction(errMsg) {
    var toastOptions: ToastOptions = {
      title: "Service Updation Form",
      msg: errMsg,
      showClose: true,
      timeout: 3000,
      theme: "bootstrap",
      onAdd: (toast: ToastData) => {},
      onRemove: function (toast: ToastData) {},
    };
    this.toastyService.warning(toastOptions);
  } //getWarningFunction end here

  getSuccessFunction(successMsg) {
    var toastOptions: ToastOptions = {
      title: "Service Updation Form",
      msg: successMsg,
      showClose: true,
      timeout: 3000,
      theme: "bootstrap",
      onAdd: (toast: ToastData) => {},
      onRemove: function (toast: ToastData) {},
    };
    this.toastyService.success(toastOptions);
  } //getSuccessFunction end here
}



// WEBPACK FOOTER //
// ./client/app/service-contract/service-contract.component.ts